module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAqwAAAKsB1E2SqwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADWSURBVEiJrZXbDoMgDEDPwz4FLz/uy37Eqdu+aIl7YQsjBVpWE2I05ZwKtQAsQDjPE88BhMgmADdPScrMXwwO8AHYPglL1m5JAv8ypE/beiQRvudzS+u3AaMBPgKHlFhtk1SSBC7GtiphB6ZKzATca4loyk2UJPBiAk1BSRLhjxZcJcgkcxxPDVwtSCRHhM/aeRds18sYb1qiNd6b1dWzyStJM7RIzHCrpAsuSGw/mgaexRbbyl9wQVJvdj3wlsQFnjF+Di03uCAJ8dkPLkkArp7wTLK8AfNFGF/xJLtqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/cancel.png
// module id = 1018
// module chunks = 0